import { useCallback, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import {
  getPublicMerchantBrandItemOptions,
  type MerchantBrandItemOption,
} from "./publicOptions.api";

interface UseGetMerchantBrandItemOptionsReturn {
  merchantBrandItemOptions: MerchantBrandItemOption[];
  fetchMerchantBrandItemOptions: (merchantBrandId: string) => Promise<void>;
  clearMerchantBrandItemOptions: () => void;
  isLoading: boolean;
  error: unknown;
}

export const useGetMerchantBrandItemOptions = (): UseGetMerchantBrandItemOptionsReturn => {
  const [merchantBrandItemOptions, setMerchantBrandItemOptions] = useState<
    MerchantBrandItemOption[]
  >([]);
  const [error, setError] = useState<unknown>(null);
  const { run: runLatestRequest, cancel, loading } = useLatestRequest();

  const fetchMerchantBrandItemOptions = useCallback(
    async (merchantBrandId: string) => {
      setMerchantBrandItemOptions([]);
      setError(null);

      try {
        const response = await runLatestRequest((signal) =>
          getPublicMerchantBrandItemOptions(merchantBrandId, signal),
        );
        if (!response) return;
        setMerchantBrandItemOptions(response);
      } catch (error) {
        setMerchantBrandItemOptions([]);
        setError(error);
      }
    },
    [runLatestRequest],
  );

  const clearMerchantBrandItemOptions = useCallback(() => {
    cancel();
    setMerchantBrandItemOptions([]);
    setError(null);
  }, [cancel]);

  return {
    merchantBrandItemOptions,
    fetchMerchantBrandItemOptions,
    clearMerchantBrandItemOptions,
    isLoading: loading,
    error,
  };
};
